// extracted by mini-css-extract-plugin
module.exports = {"hr":"HorizontalRule-hr_08925f86"};